import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';
import uuidv4 from 'uuid/v4';

// Import helpers
import { initGA, initGTM, initPixel, recordPageView } from 'helpers/tracking';
import { COOKIE_EXPIRES } from 'helpers/variables';

// Import utilities
import { useAuth } from 'components/utilities';

const useAppTemplate = () => {
	const { pathname } = useLocation();
	const { isAuth } = useAuth();

	const [cookieNotice, setCookieNotice] = useState(false);

	useEffect(() => {
		checkUID();
		checkCookieNotice();

		initGTM();
		initGA();
		initPixel();
	}, []);

	useEffect(() => {
		recordPageView();
	}, [pathname]);

	// ---------- Cookies ----------
	const checkUID = () => {
		// Get uid
		const cookies = Cookies.get('uid');
		// If uid is nod defined, create uid's cookie
		if (!cookies) {
			const createUID = uuidv4();
			Cookies.set('uid', createUID, { expires: COOKIE_EXPIRES });
		}
	};

	const checkCookieNotice = () => {
		// Gett cookie notice
		const cookieNotice = Cookies.get('cookie-notice');
		// If there is not cookie-notice show cookie message
		if (cookieNotice && cookieNotice === '1') {
			setCookieNotice(true);
		}
	};

	return { cookieNotice, isAuth };
};

export default useAppTemplate;
/* eslint-enable */
